import React from 'react'
import { Button } from 'semantic-ui-react'
import AccountInfoBar from '../../components/AccountInfoBar'
import { AccountDetails, Correspondent } from '../../types'
import CounterPartyDetails from './CounterPartyDetails'
import Fees from './Fees'
import FormDetails from './FormDetails'
import styles from './styles.module.less'
import TradeCalculations from './TradeCalculations'
import TradeInstructionsWrapper from './TradeInstructionsWrapper'
import { TradeFormErrors, TradeFormTouched, TradeFormValues } from './Types'

export interface TradeFormProps {
  accountDetails: AccountDetails
  correspondent: Correspondent
  errors: TradeFormErrors
  handleBlur: (field: string) => void
  handleChange: (e: React.ChangeEvent) => void
  onModeButtonClick: () => void
  onSubmit: () => void
  setFieldValue: (field: string, value: any) => void
  touched: TradeFormTouched
  tradeSubmissionFailedMessage?: string
  values: TradeFormValues
}

const TradeForm = ({
  accountDetails,
  correspondent,
  errors,
  handleBlur,
  handleChange,
  onModeButtonClick,
  setFieldValue,
  touched,
  values,
}: TradeFormProps) => (
  <div className="trade-form">
    <AccountInfoBar
      accountDetails={accountDetails}
      correspondent={correspondent}
      errors={errors}
      handleBlur={handleBlur}
      setFieldValue={setFieldValue}
      touched={touched}
      values={values}
    />
    <FormDetails
      errors={errors}
      handleBlur={handleBlur}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      touched={touched}
      values={values}
    />
    <CounterPartyDetails
      errors={errors}
      handleBlur={handleBlur}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      touched={touched}
      values={values}
    />
    <Fees errors={errors} onFeeBlur={handleBlur} setFieldValue={setFieldValue} touched={touched} values={values} />
    <TradeCalculations accountDetails={accountDetails} values={values} />
    <TradeInstructionsWrapper errors={errors} setFieldValue={setFieldValue} touched={touched} values={values} />
    <Button
      className={styles.previewTradeButton}
      disabled={Object.keys(errors).length > 0}
      onClick={onModeButtonClick}
      type="submit"
    >
      Preview Trade
    </Button>
  </div>
)

export default TradeForm
